<template>
<div class="container-fluid">

    <page-loading v-if="!data_loaded" />

    <div v-else class="row">
        <div class="col">
            <div class="card fill-app-height without-page-title">         

                    <iframe v-if="report.dashboard_status == 200" :src="report.dashboard_url" frameborder="none" :height="report.height ? report.height : '600px'"></iframe>

                    <div v-else class="text-lg text-gray-500 text-center my-auto">
                        <p>Oops. There was a problem loading the dashboard. Try refreshing.</p>
                        <p>Status code: {{ report.dashboard_status }}</p>
                    </div>

            </div>
        </div>
        
    </div>
</div>
</template>

<script>
    import { mapState } from 'vuex'
    import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

    export default {
        mixins: [BreadcrumbsManager],

        props: {
            id: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                report: null,
                data_loaded: false,
            }
        },

        created() {
        	this.fetchReport();           
        },

        activated() {
            this.setBreadcrumbs([
                { text: 'Home', to: { name: 'home' } },
                { text: 'Reports', to: { name: 'reports.index'} },
                { text: '[Report Name]', to: { name: 'reports.show'} },
            ]);    
        },

        methods: {
            fetchReport() {
                axios.get('/api/reports/' + this.id).then(({data}) => {
                    this.report = data;
                    this.data_loaded = true;

                    this.replaceBreadcrumb({
                        find: '[Report Name]',
                        replace: { text: this.report.title }
                    });                         
                });
            },
        }       
    }
</script>